import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface RevokePersonalAccessTokenByClientIdParams {
    userId: string;
    tokenName: string;
}

export interface RevokePersonalAccessTokenByClientIdResult  extends IResult {
}

export class RevokePersonalAccessTokenByClientIdRequest extends Request<RevokePersonalAccessTokenByClientIdParams, RevokePersonalAccessTokenByClientIdResult> {
  constructor(params: RevokePersonalAccessTokenByClientIdParams) {
    super('revokePersonalAccessTokenByName', params);
  }
}
